/**
 * HTTP layer for warehouse shipping/billing addresses. Single-address CRUD
 * against `/warehouse/addresses`.
 *
 * Contains:
 * - fetchAddresses / fetchAddress: list and detail reads
 * - postAddress / patchAddress / deleteAddress: address writes
 */
import apiClient from '@sophocles/http-common';

const ADDRESS_ENDPOINT = '/warehouse/addresses';

export const fetchAddresses = queryParams =>
  apiClient.get(`${ADDRESS_ENDPOINT}/`, { params: queryParams }).then(res => res.data);

export const fetchAddress = addressId => apiClient.get(`${ADDRESS_ENDPOINT}/${addressId}/`).then(res => res.data);

export const postAddress = data => apiClient.post(`${ADDRESS_ENDPOINT}/`, data).then(res => res.data);

export const patchAddress = (addressId, data) =>
  apiClient.patch(`${ADDRESS_ENDPOINT}/${addressId}/`, data).then(res => res.data);

export const deleteAddress = addressId => apiClient.delete(`${ADDRESS_ENDPOINT}/${addressId}/`);
